import {ProjectReferenceDocumentVisibility, ProviderDocumentVisibility} from '@frontend/shared-api';

export const CARD_VISIBILITY: Record<
  ProjectReferenceDocumentVisibility,
  ProviderDocumentVisibility
> = {
  [ProjectReferenceDocumentVisibility.PUBLIC]: ProviderDocumentVisibility.PUBLIC,
  [ProjectReferenceDocumentVisibility.CONFIDENTIAL]: ProviderDocumentVisibility.CONFIDENTIAL,
};

export const REFERENCE_DOCUMENT_VISIBILITY: Record<
  ProviderDocumentVisibility,
  ProjectReferenceDocumentVisibility
> = {
  [ProviderDocumentVisibility.PUBLIC]: ProjectReferenceDocumentVisibility.PUBLIC,
  [ProviderDocumentVisibility.CONFIDENTIAL]: ProjectReferenceDocumentVisibility.CONFIDENTIAL,
};
